import { AccrediblePageMeta } from '@accredible-frontend-v2/models';
import { AccredibleLanguageService } from '@accredible-frontend-v2/services/language';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  input,
  Input,
  Output,
} from '@angular/core';

interface ViewingFromTo {
  start: number;
  end: number;
  totalCount: number;
  pageName: string;
}

interface PageFromTo {
  currentPage: number;
  lastPage: number;
}

@Component({
  selector: 'accredible-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccrediblePaginationComponent {
  private readonly _liveAnnouncer = inject(LiveAnnouncer);
  private readonly _language = inject(AccredibleLanguageService);

  hideLabels = input<boolean>(false);

  @Input()
  useCustomViewingFromTo = false;
  @Input()
  useCustomPageFromTo = false;

  @Output()
  pageChange = new EventEmitter<number>();

  @Output()
  tabForward = new EventEmitter<void>();

  viewingFromTo: ViewingFromTo;
  pageFromTo: PageFromTo;
  private _pageMeta: AccrediblePageMeta;
  private _pageName = '';

  get pageMeta(): AccrediblePageMeta {
    return this._pageMeta;
  }

  @Input()
  set pageMeta(pageMeta: AccrediblePageMeta) {
    this._pageMeta = pageMeta;
    this.viewingFromTo = {
      start: (pageMeta.current_page - 1) * pageMeta.page_size + 1,
      end:
        pageMeta.current_page === pageMeta.total_pages
          ? pageMeta.total_count
          : pageMeta.current_page * pageMeta.page_size,
      totalCount: pageMeta.total_count,
      pageName: this.pageName,
    };
    this.pageFromTo = {
      currentPage: pageMeta.current_page,
      lastPage: pageMeta.total_pages,
    };

    if (pageMeta.total_count > 0) {
      this._liveAnnouncer.announce(
        this._language.translate('nc-pagination.aria_viewing_from_to', this.viewingFromTo),
      );
    }
  }

  get pageName(): string {
    return this._pageName;
  }

  @Input()
  set pageName(pageName: string) {
    this._pageName = pageName;

    this.viewingFromTo = {
      ...this.viewingFromTo,
      pageName,
    };
  }
}
